import { L10nTranslationService } from "angular-l10n";

export class EnumParser {

  static getNamesAndValues<T extends number>(e: any) {
    return EnumParser.getNames(e).map((n) => ({id: e[n] as T, text: this.firstToUpperCase(n)}));
  }

  static getNames(e: any) {
    return EnumParser.getObjValues(e).filter((v) => typeof v === "string") as string[];
  }

  static getValues<T extends number>(e: any) {
    return EnumParser.getObjValues(e).filter((v) => typeof v === "number") as T[];
  }

  private static getObjValues(e: any): (number | string)[] {
    return Object.keys(e).map((k) => e[k]);
  }

  private static firstToUpperCase(str) {
    str = str.replace(/_/g, " ").toLowerCase();
    return str.substr(0, 1).toUpperCase() + str.substr(1);
  }

  constructor(private translationService: L10nTranslationService) {}

  getTranslatedNamesAndValues<T extends number>(e: any, localePreString: string = "", exceptions: string[] = []) {
    return EnumParser.getNames(e)
      .filter((n) => exceptions.indexOf(n) === -1)
      .map((n) => ({
        id: e[n] as T,
        text: this.translationService.translate(localePreString + "." + n.toUpperCase())}));
  }
}
